module.exports = __webpack_public_path__ + "resources/img/solution_finance_rescue2_m_v2.6b50d9164d622a05e79531a29f809371.png";